// extracted by mini-css-extract-plugin
export default {"preRelease":"JXrPNuauB_smWwC2uHVz"};